import React from 'react';
import { motion } from "motion/react";
import { ArrowRightIcon } from '@/features/home/utils';

const HeroSection: React.FC = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
      },
    },
  };

  const buttonVariants = {
    hover: {
      scale: 1.02,
      transition: {
        duration: 0.2,
      },
    },
    tap: {
      scale: 0.98,
    },
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-950/30 via-gray-900 dark:via-black to-gray-800 dark:to-black"></div>
      <motion.div 
        className="relative max-w-8xl mx-auto px-8 text-center text-gray-900 dark:text-white"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div className="mb-8" variants={itemVariants}>
          <span className="inline-block px-4 py-2 bg-white/10 dark:bg-white/10 backdrop-blur-sm rounded-full text-sm font-medium border border-gray-200/20 dark:border-gray-200/10 text-gray-800 dark:text-white">Exclusive Access Unlocked</span>
        </motion.div>
        <motion.h1 
          className="text-[12vw] lg:text-[10rem] xl:text-[12rem] leading-[0.8] font-serif font-medium tracking-tighter mb-8"
          variants={itemVariants}
        >
          <span>Unlock</span><span className="block">The Night</span>
        </motion.h1>
        <motion.div 
          className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 text-lg font-light leading-relaxed mb-12"
          variants={itemVariants}
        >
          <p className="opacity-80">Book tables and tickets seamlessly at the world's most exclusive nightclubs.</p>
          <p className="opacity-80">Your unforgettable night is just a few clicks away. Experience the best of global nightlife.</p>
        </motion.div>
        <motion.div 
          className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16"
          variants={itemVariants}
        >
          <motion.button 
            className="group px-8 py-4 bg-blue-600 dark:bg-white text-white dark:text-black rounded-full font-medium hover:bg-blue-700 dark:hover:bg-gray-200 transition-all duration-300"
            variants={buttonVariants}
            whileHover="hover"
            whileTap="tap"
          >
            <span className="flex items-center gap-2">Explore Venues<ArrowRightIcon /></span>
          </motion.button>
          <motion.button 
            className="px-8 py-4 border border-gray-300 dark:border-gray-700 rounded-full font-medium hover:bg-gray-100 dark:hover:bg-white/10 hover:shadow-lg transition-all duration-300 text-gray-800 dark:text-white"
            variants={buttonVariants}
            whileHover="hover"
            whileTap="tap"
          >
            Find An Event
          </motion.button>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
